import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AboutV2 = () => {
  const [formations, setFormations] = useState([]);
  const publicUrl = process.env.PUBLIC_URL + '/';
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/modeFormation/all`)
      .then((res) => {
        if (res.data && res.data.data) {
          setFormations(res.data.data.filter((item) => item.isDeleted === 0));
        }
      })
      .catch((err) => {
        console.error(
          'Erreur lors de la récupération des modes de formation :',
          err,
        );
      });
  }, []);

  return (
    <div style={{ backgroundColor: '#f8f8f8' }}>
      <div className="container">
        <div className="section-title">
          <h3
            className="titleAbout"
            style={{ textAlign: 'center', color: 'black' }}
          >
            {formations[0]?.ModeTitre || 'Nos modes de formation :'}
          </h3>
        </div>
        <div className="row">
          {formations.map((mode, index) => (
            <div className="col-lg-4 col-md-12 mt-5 mb-5" key={mode.ModeId}>
              <div className="single-intro-inner style-icon-bg text-center">
                <div className="thumb">
                  <img src={`${Url}/images/${mode.ModeIcone}`} alt="icon" />
                </div>
                <div className="details">
                  <h5 style={{ height: '50px' }}>{mode.SousTitre}</h5>
                  {/* Texte justifié */}
                  <p style={{ textAlign: 'justify' }}>{mode.ModeDescription}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutV2;
